import { render, staticRenderFns } from "./verified.vue?vue&type=template&id=90da1276&scoped=true&"
import script from "./verified.vue?vue&type=script&lang=js&"
export * from "./verified.vue?vue&type=script&lang=js&"
import style0 from "./verified.vue?vue&type=style&index=0&id=90da1276&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90da1276",
  null
  
)

export default component.exports